import { useCallback } from 'react';

export function useAirportValidation(state, setState) {  
  const validate = useCallback(() => {
    const errors = { ...state.errors };
    let formIsValid = true;

    // Reset all relevant errors
    errors.airlineId = '';
    errors.flightNumber = '';
    errors.pilotCount = '';
    errors.flightTime = '';
    errors.airlineIdReturn = '';
    errors.flightNumberReturn = '';
    errors.pilotCountReturn = '';
    errors.flightTimeReturn = '';
    errors.pickupLocation = '';
    errors.pickupZoneId = '';
    errors.dropoffLocation = '';
    errors.dropoffZoneId = '';
    errors.puDateTime = '';
    errors.puDateTimeReturn = '';
    errors.vehicleTypeId = '';
    errors.noOfTrip = '';
    errors.recurringEndDate = '';
    errors.recurring = '';
    errors.otherAffiliateId = '';
    errors.mobileNumber = '';
    errors.email = '';

    // Mobile validation (only if provided)
    if (state.mobileNumber.trim() !== '') {
      if (state.mobileNumber.trim().replace('(', '').replace(')', '').replace('-', '').replace(' ', '').length !== 10) {
        formIsValid = false;
        errors.mobileNumber = 'Invalid mobile number.';
      }
    }

    if (state.airlineId === 0) {
      formIsValid = false;
      errors.airlineId = 'Please select airline.';
    }
    if (state.flightNumber.trim() === '') {
      formIsValid = false;
      errors.flightNumber = 'Please enter flight #.';
    }
    if ((parseInt(state.pilotCount | 0) + parseInt(state.crewCount | 0) + parseInt(state.flightAttandCount | 0)) === 0) {
      formIsValid = false;
      errors.pilotCount = 'Required.';
    }

    if (state.tripTypeId === '2') {
      if (state.airlineIdReturn === 0) {
        formIsValid = false;
        errors.airlineIdReturn = 'Please select airline.';
      }
      if (state.flightNumberReturn.trim() === '') {
        formIsValid = false;
        errors.flightNumberReturn = 'Please enter flight #.';
      }
      if ((parseInt(state.pilotCountReturn | 0) + parseInt(state.crewCountReturn | 0) + parseInt(state.flightAttandCountReturn | 0)) === 0) {
        formIsValid = false;
        errors.pilotCountReturn = 'Required.';
      }
      if (state.flightTimeReturn == null) {
        formIsValid = false;
        errors.flightTimeReturn = 'Please enter flight time.';
      }
      if (state.puDateTimeReturn == null) {
        formIsValid = false;
        errors.puDateTimeReturn = 'Please enter date and time.';
      }
    }

    if (state.pickupLocation.trim() === '') {
      formIsValid = false;
      errors.pickupLocation = 'Please enter pick-up location.';
    }
    if (state.pickupZoneId === 0) {
      formIsValid = false;
      errors.pickupZoneId = 'Please select pick-up zone.';
    }
    if (state.dropoffLocation.trim() === '') {
      formIsValid = false;
      errors.dropoffLocation = 'Please enter drop off location.';
    }
    if (state.dropoffZoneId === 0) {
      formIsValid = false;
      errors.dropoffZoneId = 'Please select drop off zone.';
    }
    if (state.puDateTime == null) {
      formIsValid = false;
      errors.puDateTime = 'Please enter pick-up date time.';
    }

    if (state.vehicleTypeId === 0) {
      formIsValid = false;
      errors.vehicleTypeId = 'Please select vehicle type.';
    }
    if (parseInt(state.noOfTrip | 0) === 0) {
      formIsValid = false;
      errors.noOfTrip = 'Please enter trip count.';
    }
    if (state.serviceSourceId == 2 || state.serviceSourceId == 3) {
      if (state.otherAffiliateId === 0) {
        formIsValid = false;
        errors.otherAffiliateId = 'Please select affiliate.';
      }
    }

    if (state.tripTypeId === '3') {
      if (state.recurringEndDate === '' || state.recurringEndDate === null) {
        formIsValid = false;
        errors.recurringEndDate = 'Please enter recurring end date.';
      }
      if (state.recurringTypeId == 1 && state.selectedDays.length === 0) {
        formIsValid = false;
        errors.recurring = 'Please select recurring days.';
      }
      if (state.recurringTypeId == 2) {
        if (!state.isWeekSun && !state.isWeekMon && !state.isWeekTue && !state.isWeekWed && !state.isWeekThu && !state.isWeekFri && !state.isWeekSat) {
          formIsValid = false;
          errors.recurring = 'Please select recurring days.';
        }
      }
      if (state.recurringTypeId == 3) {
        if (!state.isMonthSun && !state.isMonthMon && !state.isMonthTue && !state.isMonthWed && !state.isMonthThu && !state.isMonthFri && !state.isMonthSat) {
          formIsValid = false;
          errors.recurring = 'Please select recurring days.';
        }
      }
    }

    if (state.isSendEmail === true) {
      if (state.email.trim() === '') {
        formIsValid = false;
        errors.email = 'Please enter email.';
      }
    }
    if (state.email !== '') {
      const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regEmail.test(state.email)) {
        formIsValid = false;
        errors.email = 'Please enter valid email.';
      }
    }

    setState({ errors });
    return formIsValid;
  }, [state, setState]);

  return { validate };
}
